import { Navigation, CasesContainer } from '../components/case-studies/styles'
import { Helmet } from 'react-helmet'

import { SEOCases } from '../components/case-studies/SEOCases'
import { WebCases } from '../components/case-studies/WebCases'
import { AdCases } from '../components/case-studies/AdCases'
import { SocialCases } from '../components/case-studies/SocialCases'

import * as React from 'react'
import Layout from '../components/Layout'
import Header from '../components/Header'
import { Link, graphql } from 'gatsby'
import Img from 'gatsby-image'

import { Box, Flex } from 'grid-styled'
import CTA from '../components/CTA'
import GalleryContainer from '../components/GalleryContainer'
import GalleryImage from '../components/GalleryImage'

export default ({ data }) => (
  <Layout>
    <Helmet>
      <title>Gallery - GFit Sportswear</title>
      <meta
        name="description"
        content="Check our some of our custom apparrel and sportswear in action in these gallery shots."
      />
    </Helmet>
    <Header>
      <h1>GFit Gallery</h1>
    </Header>

    <GalleryContainer>
      {data.gallery.edges.map(
        (image, i) =>
          image.node.childImageSharp && (
            <GalleryImage modal={image.node.childImageSharp.modal}>
              <Img fixed={image.node.childImageSharp.fixed} />
            </GalleryImage>
          )
      )}
    </GalleryContainer>
  </Layout>
)

export const query = graphql`
  query GalleryQuery {
    gallery: allFile(filter: { relativeDirectory: { eq: "gallery" } }) {
      edges {
        node {
          childImageSharp {
            fixed(width: 400, height: 400, toFormat: JPG) {
              ...GatsbyImageSharpFixed
            }
            modal: fluid(maxWidth: 1200, quality: 98, toFormat: JPG) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
